import { useLayoutEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import Layout from 'src/layout'
import AboutUs from './AboutUs'
import Contact from './Contact'
import Home from './Home'
import Products from './Products'
import GISSolutions from './GISSolutions'
import Softwares from './Softwares'
import SystemSolutions from './SystemSolutions'
import TrafficSimulation from './TrafficSimulation'
import UnderConstruction from './UnderConstruction'

const Wrapper = (props: any) => {
  const location = useLocation()
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0)
  }, [location.pathname])
  return props.children
}

const index = () => {
  return (
    <BrowserRouter>
      <Wrapper>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/system-solutions" element={<SystemSolutions />} />
            <Route path="/gis-solutions" element={<GISSolutions />} />
            <Route path="/softwares" element={<Softwares />} />
            <Route path="/traffic-simulation" element={<TrafficSimulation />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<UnderConstruction />} />
          </Routes>
        </Layout>
      </Wrapper>
    </BrowserRouter>
  )
}

export default index
